import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import { getMerchantType } from "../../../redux/actions/merchantActions";
import { getAllCategorys } from "../../../redux/actions/categories";
import { getReport } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class SalesByOffer extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'SALES_BY_OFFER',
      path: ["Home", "Sales by Offer Report"],
      links: ["home", "report/sales-by-offer"],
      date: new Date(),
      limit: 10,
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      range: false,
      disabled: false,
      catID: "",
      merchantTypeID: "",
      dealType: "",
      sales: [],
      isLoading: "false",
      csvData: "",
      offerIDs: "",
      reportData : "",
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    if(e.target.name == 'dealType'){
      this.props.getAllCategorys({categoryType: e.target.value, page:0});
      this.setState({catID: ''});
    }
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      this.setState({ sales: "" });
      let formData = {
        page: 1,
        limit: this.state.limit,
        catID: this.state.catID,
        merchantTypeID: this.state.merchantTypeID,
        dealType: this.state.dealType,
        offerIDs: this.state.offerIDs,
      };

      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData.startDate = moment(dateRange[0]).format('YYYY-MM-DD');
        formData.endDate = moment(dateRange[1]).format('YYYY-MM-DD');
      } else {
        formData.startDate = moment(this.state.startDate).format('YYYY-MM-DD');
      }
      
      this.props.getReport(formData, 'report/sales-by-offer');  
    }
  }

  Clear = () => {};

  handlePageChange = page => {
    this.setState({ sales: "", currentPage: page });

    let formData = {
      page: page,
      limit: this.state.limit,
      catID: this.state.catID,
      merchantTypeID: this.state.merchantTypeID,
      dealType: this.state.dealType,
      offerIDs: this.state.offerIDs,
    };

    if (this.state.range == true) {
      let dateRange = this.state.startDateRange;
      formData.startDate = moment(dateRange[0]).format('YYYY-MM-DD');
      formData.endDate = moment(dateRange[1]).format('YYYY-MM-DD');
    } else {
      formData.startDate = moment(this.state.startDate).format('YYYY-MM-DD');
    }

    this.props.getReport(formData, 'report/sales-by-offer'); 
  };

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getMerchantType();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      if(siteData.combine_products == 'disable') {
        this.setState({dealType: 'offer'});
        this.props.getAllCategorys({categoryType: 'offer', page:0});
      }else{
        this.props.getAllCategorys({categoryType: this.state.dealType, page:0});
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)) {
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ sales: "" });
      }
    }

    if (this.props.merchantType !== nextProps.merchantType) {
      if (nextProps.merchantType) {
        this.setState({ merchantType: nextProps.merchantType });
      }
    }

    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        this.setState({ catData: nextProps.catData.data });
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        const reportDataRecords = nextProps.reportData.data
        const setPageCount =
          reportDataRecords.total / reportDataRecords.per_page;
        this.setState({
          userList: reportDataRecords.data,
          totalRecords: reportDataRecords.total,
          perPage: reportDataRecords.per_page,
          pageCount: setPageCount
        });
        
        isLoading = "false";
        this.setState({ reportData: nextProps.reportData.data.data });
        this.handleExport(nextProps.reportData.data.data);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleExport = data => {
    csvData = [
      [
        // "#",
        "Type",
        "Proposal Type",
        "Offer ID",
        "SKU Code",
        "Offer Name",
        "Original Price",
        "Offer Price",
        "Launch Date",
        "End Date",
        "Manually Generated",
        "City",
        "State",
        "Country", 
        "Currency",
        "Credit Card Sale",
        "User Credits Used ",
        "Promo Code Credit Used",
        "Gross Sale",
        "Shipping to Site",
        "Shipping to Merchant",
        "Tax Percentage",
        "Tax Amount",
        "Credit Card %",
        "Credit Card Fee",
        "Refunds",
        "Credit Card Refund",
        "Store Credit Refund",
        "Offline Refund",
        "Adjusted Gross",
        "Site Commission",
        "Site Commission %",
        "Merchant Remittance",
        "Merchant Remittance %",
        "Net Payout To Merchant",
        "Final Merchant Payout ",
        "Net To Site",
        "Payment Method",
        "Sales Rep Full Name",
        "Payment Status",
        "Pricing Option Deal Title",
        "Offer Option",
        "Merchant ID",
        "Merchant Legal Name",
        "Merchant Email",
        "Phone",
        "Vouchers",
        "Voucher To be Sold",
        "Gross Billing",
        "Payvibe Commission",
        "Payvibe Commission %", 
        "Categories", 
        "Additional Notes"
      ]
    ];
    {data &&
      data.map((tran, index) =>
        csvData.push([
          // ++index,
          (tran.proposal_type_id == '10') ? 'Product' : (tran.proposal_type_id == '11') ? 'Auction' : 'Offer',
          tran.proposal_type,
          tran.offer_id,
          (tran.skuCode !== 'null') ? tran.skuCode : '',
          tran.offer_name,
          tran.original_price,
          tran.offer_price,
          tran.launch_date,
          tran.end_date,
          (tran.is_manually_generated == '1') ? 'Yes' : 'No',
          tran.city_name,
          tran.state_name,
          tran.country_name, 
          tran.currency,
          tran.credit_card_sale,
          tran.user_credit_used,
          tran.promo_credit_used,
          tran.gross_sale,
          tran.shipping_to_site,
          tran.shipping_to_merchant,
          tran.tax_percentage,
          tran.tax_amount,
          tran.credit_card_percentage,
          tran.credit_card_fee,
          tran.refund_amount,
          tran.auth_refund_amount,
          tran.store_refund_amount,
          tran.offline_refund_amount,
          tran.adjusted_gross_sale,
          tran.site_commission,
          tran.site_commission_percentage,
          tran.merchant_remittance,
          tran.merchant_commission_percentage,
          tran.net_payout_to_merchant,
          tran.final_merchant_payout,
          tran.net_to_site,
          tran.payment_method,
          tran.sales_representative_fullname,
          tran.payment_status,
          "",
          JSON.stringify(tran.offer_options).replace(/,/g, '||'),
          tran.merchant_id,
          tran.legalName,
          tran.merchant_email,
          tran.merchant_phone,
          tran.vouchers,
          tran.quantityToSold,
          tran.gross_billing,
          "",
          "", 
          tran.categories, 
          tran.notes
        ])
      )
    }

    this.setState({ csvData: csvData });
  };

  render() {
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Sales by Offer Report</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="formParentID">
                    <ControlLabel>Deal Type</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="dealType"
                        onChange={this.handleChange}
                        placeholder="select"
                        value={this.state.dealType}
                      >
                        <option value="">All</option>
                        <option value="offer">Offer</option>
                        <option value="products">Products</option>
                        <option value="auction">Auction</option>
                      </FormControl>
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="offerIDs">
                    <ControlLabel>Deal IDs(separate by comma)</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.offerIDs}
                      placeholder="Deal ID"
                      onChange={this.handleChange}
                      name="offerIDs"
                    />
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="proposalType">
                    <ControlLabel>Proposal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.merchantTypeIDError }}
                      name="merchantTypeID"
                      onChange={this.handleChange}
                      value={this.state.merchantTypeID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.merchantType) &&
                        this.state.merchantType.map((type, index) => (
                          <option
                            key={type.merchantTypeID}
                            value={type.merchantTypeID}
                          >
                            {type.merchantTypeName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>

                <Col md={3} xs={12}>
                  <FormGroup controlId="catID">
                    <ControlLabel>Category</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.catIDError }}
                      name="catID"
                      onChange={this.handleChange}
                      value={this.state.catID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.catData) &&
                        this.state.catData.map((type, index) => (
                          <option key={type.catID} value={type.catID}>
                            {type.catName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"sales-by-offer.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Type</th>
                  <th>Proposal Type</th>
                  <th>Offer ID</th>
                  <th>SKU Code</th>
                  <th>Offer Name</th>
                  <th>Original Price</th>
                  <th>Offer Price</th>
                  <th>Launch Date</th>
                  <th>End Date</th>
                  <th>Manually Generated</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Country</th>  
                  <th>Currency</th>
                  <th>Credit Card Sale</th>
                  <th>User Credits Used </th>
                  <th>Promo Code Credit Used</th>
                  <th>Gross Sale</th>
                  <th>Shipping to Site</th>
                  <th>Shipping to Merchant</th>
                  <th>Tax Percentage</th>
                  <th>Tax Amount</th>
                  <th>Credit Card %</th>
                  <th>Credit Card Fee</th>
                  <th>Refunds</th>
                  <th>Credit Card Refund</th>
                  <th>Store Credit Refund</th>
                  <th>Offline Refund</th>
                  <th>Adjusted Gross</th>
                  <th>Site Commission</th>
                  <th>Site Commission %</th>
                  <th>Merchant Remittance</th>
                  <th>Merchant Remittance %</th>
                  <th>Net Payout To Merchant</th>
                  <th>Final Merchant Payout </th>
                  <th>Net To Site</th>
                  <th>Payment Method</th>
                  <th>Sales Rep Full Name</th>
                  <th>Payment Status</th>
                  <th>Pricing Option Deal Title</th>
                  <th>Offer Option</th>
                  <th>Merchant ID</th>
                  <th>Merchant Legal Name</th>
                  <th>Merchant Email</th>
                  <th>Phone</th>
                  <th>Vouchers</th>
                  <th>Voucher To be Sold</th>
                  <th>Gross Billing</th>
                  <th>Payvibe Commission</th>
                  <th>Payvibe Commission %</th>  
                  <th>Categories</th> 
                  <th>Additional Notes</th>
                </tr>
              </thead>
              <tbody>
                {!isEmpty(this.state.reportData) ? (
                  this.state.reportData.map((tran, index) => (
                    <tr key={Math.random()+index}>
                      <td>{++index}</td>
                      <td>{(tran.proposal_type_id == '10') ? 'Product' : (tran.proposal_type_id == '11') ? 'Auction' : 'Offer'}</td>
                      <td>{tran.proposal_type}</td>
                      <td>{tran.offer_id}</td>
                      <td>{(tran.skuCode !== 'null') ? tran.skuCode : ''}</td>
                      <td>{tran.offer_name}</td>
                      <td>{tran.original_price}</td>
                      <td>{tran.offer_price}</td>
                      <td>{tran.launch_date}</td>
                      <td>{tran.end_date}</td>
                      <td>{(tran.is_manually_generated == '1') ? 'Yes' : 'No'}</td>
                      <td>{tran.city_name}</td>
                      <td>{tran.state_name}</td>
                      <td>{tran.country_name}</td> 
                      <td>{tran.currency}</td>
                      <td>{tran.credit_card_sale}</td>
                      <td>{tran.user_credit_used}</td> {/*User Credits Used*/}
                      <td>{tran.promo_credit_used}</td>
                      <td>{tran.gross_sale}</td>
                      <td>{tran.shipping_to_site}</td>
                      <td>{tran.shipping_to_merchant}</td>
                      <td>{tran.tax_percentage}</td>
                      <td>{tran.tax_amount}</td>
                      <td>{tran.credit_card_percentage}</td>
                      <td>{tran.credit_card_fee}</td>
                      <td>{tran.refund_amount}</td>
                      <td>{tran.auth_refund_amount}</td>
                      <td>{tran.store_refund_amount}</td>
                      <td>{tran.offline_refund_amount}</td>
                      <td>{tran.adjusted_gross_sale}</td> {/*Adjusted Gross*/}
                      <td>{tran.site_commission}</td>
                      <td>{tran.site_commission_percentage}</td>
                      <td>{tran.merchant_remittance}</td>
                      <td>{tran.merchant_commission_percentage}</td>
                      <td>{tran.net_payout_to_merchant}</td>
                      <td>{tran.final_merchant_payout}</td>
                      <td>{tran.net_to_site}</td>
                      <td>{tran.payment_method}</td>
                      <td>{tran.sales_representative_fullname}</td>
                      <td>{tran.payment_status}</td>
                      <td>{""}</td> {/*Pricing Option Deal Title*/}
                      <td>{tran.offer_options}</td> {/*Offer Option*/}
                      <td>{tran.merchant_id}</td>
                      <td>{tran.legalName}</td>
                      <td>{tran.merchant_email}</td>
                      <td>{tran.merchant_phone}</td>
                      <td>{tran.vouchers}</td>
                      <td>{tran.quantityToSold}</td>
                      <td>{tran.gross_billing}</td>
                      <td>{""}</td> {/*Payvibe Commission*/}
                      <td>{""}</td> {/*Payvibe Commission %*/}  
                      <td>{tran.categories}</td> {/*Categories*/} 
                      <td>{tran.notes}</td>
                    </tr>
                  ))
                ) : (
                  <tr key={Math.random()}>
                    <td colSpan="68">Data Not Available</td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button className="btn btn-default"
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button className="btn btn-default"
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button className="btn btn-default"
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              <div className="clearfix" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    merchantType: state.merchantReducer.merchantType,
    catData: state.categoryReducer.catData,
    reportData: state.reportReducer.reportData
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getMerchantType,
    getAllCategorys,
    getReport
  })
)(SalesByOffer);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/SalesByOffer.js